import Button from '@blocks/Button'
import EmphasizedContent from '@blocks/EmphasizedContent'
import Grid from '@blocks/Grid'
import Input from '@blocks/Input'
import React from 'react'
import { useParams } from 'react-router'
import Ebook from './components/Ebook'
import { ReactComponent as DownloadIcon } from '@icons/download.svg'

export default function FinishedFiles() {
    const { id } = useParams<{ id: string }>()

    return (
        <Grid gap="15px">
            <Grid gap="0px">
                <small>Files</small>
                <hr />
            </Grid>
            <Grid columns="3" gap="15px">
                <EmphasizedContent>
                    <Grid gap="5px">
                        <small>Acceptances List</small>
                        <Button type="tertiary" icon={<DownloadIcon />} element="a" href={`/api/admin/salons/${id}/files/acceptances`} target="_blank">Download</Button>
                    </Grid>
                </EmphasizedContent>
                <EmphasizedContent>
                    <Grid gap="5px">
                        <small>Awards List</small>
                        <Button type="tertiary" icon={<DownloadIcon />} element="a" href={`/api/admin/salons/${id}/files/awards`} target="_blank">Download</Button>
                    </Grid>
                </EmphasizedContent>
                <EmphasizedContent>
                    <Ebook />
                </EmphasizedContent>
            </Grid>
            <Grid gap="15px" columns="2">
                <EmphasizedContent>
                    <Grid gap="5px">
                        <small>Winners: Photos</small>
                        <Button type="tertiary" icon={<DownloadIcon />} element="a" href={`/api/admin/salons/${id}/files/winners`} target="_blank">Download</Button>
                    </Grid>
                </EmphasizedContent>
                <EmphasizedContent>
                    <Grid gap="5px">
                        <small>Winners: Contacts List</small>
                        <Button type="tertiary" icon={<DownloadIcon />} element="a" href={`/api/admin/salons/${id}/files/contacts`} target="_blank">Download</Button>
                    </Grid>
                </EmphasizedContent>
            </Grid>
        </Grid>
    )
}